import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import  ReactMarkdown from 'react-markdown';
import TrackableButton from './TrackableButton'

class Info extends React.Component {
  constructor(){
    super();
    this.submit = this.submit.bind(this);
  }
  submit = e => {
    e.preventDefault();
    this.props.onAcceptTerms(
      {
        csrf_token: ReactOnRails.authenticityToken()
      }
    );
  }
  withdraw = e => {
    e.preventDefault();
    if (confirm(this.props.content.pages.withdraw.confirm)){
      this.props.onWithdrawSubmit({
        csrf_token: ReactOnRails.authenticityToken()
      });
    }
  }
  render() {
    const thisPage = P.INFO_PAGE;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div>
        <Redirector this_page={thisPage} page={page}/>
        <FormHeader title={content.pages.info.title}/>
        <ReactMarkdown source={content.pages.info.body}/>
        <div className={`well scrollbox ${content.territory_code}`}>
          <ReactMarkdown source={content.pages.info.scroll_box} />
        </div>
        <p className="call-to-action">{content.pages.info.call_to_action}</p>
        <div className="row">
          <div className="col-xs-5">
            <FormGroup>
              <TrackableButton
                type="button"
                page={page}
                user={this.props.user}
                text={content.pages.withdraw.button_text}
                onClick={this.withdraw}/>
            </FormGroup>
            <small className="text-muted info-disclaimer">{content.pages.withdraw.disclaimer}</small>
          </div>
          <div className="col-xs-7 text-right">
            <TrackableButton
              type="submit"
              className='btn-primary pull-right'
              page={page}
              user={this.props.user}
              text={content.continue}
              onClick={this.submit} />
          </div>
        </div>
      </div>
    );
  }
}

Info.propTypes = {
   onAcceptTerms: PropTypes.func,
   onWithdrawSubmit: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(Info);
